import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { ViewState } from '#components/Root/viewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import { ATTRIBUTE_TAXOFFICE } from '../../utils/constants'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  taxOffice?: string | null

  handleNext: () => void
  handleBack: () => void
  handleFormChange: (Object) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    taxOffice: null,

    handleNext: mobx.action(() => {
      state.customAttributes.set(ATTRIBUTE_TAXOFFICE, vm.taxOffice)
      transitioner.goForward(
        state.currentNode.nextNode && state.currentNode.nextNode.id,
      )
    }),
    handleBack: mobx.action(() => {
      state.customAttributes.delete(ATTRIBUTE_TAXOFFICE)
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { taxOffice } = values
      vm.taxOffice = taxOffice
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
